// import React from 'react';
// import './Layout.css';
// import { useBackground } from '../context/BackgroundContext'; 


// const Layout = ({ children }) => {
//   const defaultBackground = '../assets/background.jpg';
//   const { backgroundImage } = useBackground();
//   return (
//     <div className="page-container-layout"
//     style={{ backgroundImage: backgroundImage ? `url(${backgroundImage})` : defaultBackground }}>
//       <main className="content-area-layout">
//         {children}
//       </main>
//     </div>
//   );
// };

// export default Layout;

import React from 'react';
import './Layout.css';
import { useBackground } from '../context/BackgroundContext'; 

const Layout = ({ children }) => {
  const { backgroundImage } = useBackground();

  return (
    <div className="page-container-layout">
      {/* 
         We use an inline style for the desktop background (dynamic),
         but the CSS class will override this on mobile.
      */}
      <div 
        className="layout-background-image"
        style={{ backgroundImage: backgroundImage ? `url(${backgroundImage})` : `none` }}
      ></div>

      <main className="content-area-layout">
        {children}
      </main>
    </div>
  );
};

export default Layout;